export const birthDates = [
    { en: "1900–1909", ga: "1900–1909", id: "1900" },
    { en: "1910–1919", ga: "1910–1919", id: "1910" },
    { en: "1920–1929", ga: "1920–1929", id: "1920" },
    { en: "1930–1939", ga: "1930–1939", id: "1930" },
    { en: "1940–1949", ga: "1940–1949", id: "1940" },
    { en: "1950–1959", ga: "1950–1959", id: "1950" },
    { en: "1960–1969", ga: "1960–1969", id: "1960" },
    { en: "1970–1979", ga: "1970–1979", id: "1970" },
    { en: "1980–1989", ga: "1980–1989", id: "1980" },
    { en: "1990–1999", ga: "1990–1999", id: "1990" }
];

export const genders = [
    { en: "female", ga: "baineann", id: "f" },
    { en: "male", ga: "fireann", id: "m" }
];

export const media = [
    { en: "audio files available", ga: "comhaid fuaime ar fáil", id: "audio" }
];